import i18next from "i18next"
import { initReactI18next } from "react-i18next"

// JSON imports work, but don't support interpolation checks.
// See https://github.com/microsoft/TypeScript/issues/32063
import enTranslation from "../translations/en/translation"

export const resources = {
	en: {
		translation: enTranslation,
	},
}

i18next.use(initReactI18next).init({
	lng: "en",
	resources,
	interpolation: {
		// React already escapes by default
		escapeValue: false,
	},
})

export default i18next
